/**
 * Pure route helpers for the portal shell.
 *
 * Kept in a sibling `.ts` so the predicate is unit-testable without rendering
 * the whole PortalLayout (which pulls in Auth, Router, and several services).
 */

/**
 * True on the voice-first Quality Co-Pilot route, where the portal shell drops
 * the must-acknowledge critical bar AND the 20px content inset, so the page is a
 * clean, full-bleed extension of the navbar. Matches the route exactly or any
 * sub-path — but NOT a different route that merely shares the prefix
 * (e.g. `/portal/quality-copilot-archive`).
 */
export function isQualityCopilotRoute(pathname: string): boolean {
  return (
    pathname === '/portal/quality-copilot' ||
    pathname.startsWith('/portal/quality-copilot/')
  );
}

/**
 * True on John Kirk's Tech Support Co-Pilot route, which (like the Quality
 * Co-Pilot) gets a clean, full-bleed canvas: no must-acknowledge critical bar
 * and no portal content inset (see `.mainFlush`). Matches the route exactly or
 * any sub-path — but NOT a different route that merely shares the prefix.
 */
export function isTechSupportCopilotRoute(pathname: string): boolean {
  return (
    pathname === '/portal/tech-support-copilot' ||
    pathname.startsWith('/portal/tech-support-copilot/')
  );
}

/**
 * True on the Analyst route, which (like the other co-pilot doors) gets a clean,
 * full-bleed chat canvas: no must-acknowledge critical bar and no portal content
 * inset (see `.mainFlush`). Matches the route exactly or any sub-path — but NOT a
 * different route that merely shares the prefix.
 */
export function isAnalystRoute(pathname: string): boolean {
  return (
    pathname === '/portal/analyst' || pathname.startsWith('/portal/analyst/')
  );
}

/**
 * The Knowledge Banks tab (/portal/knowledge-banks) embeds the hosted KB
 * Explorer (/kb-explorer/) in an iframe that must fill the area below the
 * navbar, so it takes the same full-bleed layout as the co-pilot doors.
 */
export function isKnowledgeBanksRoute(pathname: string): boolean {
  return (
    pathname === '/portal/knowledge-banks' || pathname.startsWith('/portal/knowledge-banks/')
  );
}
